package org.multiplatform.kotfolio.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.theme.colors.ColorMode


import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun CircularProgressIndicator(modifier: Modifier = Modifier) {
        Div(
            attrs = Modifier
                .size(30.px)
                .position(Position.Relative)
                .then(modifier)
                .toAttrs()
        ) {
            Div(
                attrs = Modifier
                    .fillMaxSize()
                    .border(2.px, LineStyle.Solid, ColorMode.current.toPalette().color)
                    .borderTop(color = Color("#007bff"))
                    .borderRadius(50.percent)
                    .animation(
                        Animation.of(
                            "spin",
                            1.1.s,
                            AnimationTimingFunction.Linear,
                            iterationCount = AnimationIterationCount.Infinite
                        )
                    )
                    .toAttrs()
            )
        }
}

val Spin = Keyframes {
    from {
        Modifier
            .transform { rotate(0.deg) }
    }
    to {
        Modifier
            .transform { rotate(360.deg) }
    }
}